$(function() {
    $('dl').prev('h2').remove();
})